import AddBlogAPI from "./addBlogAPI";

const AddBlogService = async (data: any): Promise<any> => {
  try {
    return await AddBlogAPI(data);
  } catch (error) {
    throw error;
  }
};

export default AddBlogService;
